module.exports = __webpack_public_path__ + "static/media/Gallery-23.1f1f37b8.jpg";